// SessionContext — the cross-cutting session state (current user + auth actions).
//
// Phase 3 of the portal.jsx architecture refactor (docs/portal-architecture-refactor-plan.md
// §2.5). This is the CONSERVATIVE step: App still OWNS the session state (the useState +
// useAuthSession + usePasswordRecovery wiring stays in portal.jsx); this context simply
// EXPOSES that already-built value so screens stop receiving `user` as a prop. Moving the
// state itself into the provider body is deferred to Phase 5 (SessionGate), because it
// touches the live login / recovery flow that only a smoke test can fully verify.
//
// Usage:
//   <SessionProvider value={{ user, login, logout }}> ... </SessionProvider>
//   const { user, logout } = useSession();

import { createContext, useContext } from "react";

// null sentinel = "no provider above me"; useSession throws on it so a missing
// provider fails loudly in a test rather than silently handing back undefined.
const SessionContext = createContext(null);

export function SessionProvider({ value, children }) {
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  const ctx = useContext(SessionContext);
  if (ctx === null) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return ctx;
}
